<template>
  <FocusTrap
  :initial-focus="() => $refs.closePopUp"
  :escapeDeactivates="true"
  @deactivate="onDeactivateFocusTrap()"
  ref="focusTrapHelpPopup">
  <div class="z-30 fixed w-full h-full top-0 left-0 flex items-center justify-center bg-gray-400 bg-opacity-50 mx-auto">
    <div v-click-outside="hidePopup" class="xl:w-1/4 lg:w-1/2 md:w-2/3 sm:w-full inset-0 my-4 p-8 max-h-screen overflow-y-scroll md:overflow-hidden bg-bluegray-200">
      <div class="flex justify-between h-6 mb-8">
        <h1 class="font-semibold text-xl flex-row pb-9">Bekreft</h1>
        <button @click="hidePopup" class="cursor-pointer">
          <font-awesome-icon class="font-semibold text-xl" icon="times" />
        </button>
      </div>
      <div class="flex flex-col">
        <div class="flex flex-row justify-center w-full mb-4">
          <p>{{text}}</p>
        </div>
        <div class="flex flex-row space-x-4 justify-center w-full">
          <button class="btn btn--small btn--charcoalgray" @click="confirm" ref="closePopup">Ja</button>
          <button class="btn btn--small btn--charcoalgray" @click="hidePopup" ref="closePopup">Nei</button>
        </div>
      </div>
    </div>
  </div>
  </FocusTrap>
</template>

<script>
  import vClickOutside from 'click-outside-vue3';
  import { FocusTrap } from 'focus-trap-vue';
  import { HIDE_MODAL } from '@/store/modules/appContext';

  export default {
    components: {
      FocusTrap,
    },
    props: {
      text: {
        type: String,
        required: true,
      },
    },
    directives: {
      clickOutside: vClickOutside.directive,
    },
    methods: {
      confirm() {
        this.$emit('close');
        this.$emit('confirm');
        this.$store.commit(HIDE_MODAL);
      },
      hidePopup() {
        this.$emit('close');
        this.$store.commit(HIDE_MODAL);
      },
      onDeactivateFocusTrap() {
        this.hidePopup();
      },
    },
  };
</script>
